export default "__VITE_ASSET__8124a9f4__"